// Configuration file for IT Portal Frontend
// This file contains global configuration settings that can be changed in one place

export default {
  // Base API URL for all API requests
  apiBaseUrl: 'https://www.archipelagointernational.com/api/it-portal',
  
  // Base path for static assets during build
  publicPath: '/it-portal/',
  
  // Other global configuration settings can be added here
  appName: 'IT Portal',
  version: '1.0.0',
  
  // Helper function to build full API URL paths
  getApiUrl(endpoint) {
    // Remove leading slash if present in the endpoint
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${this.apiBaseUrl}/${cleanEndpoint}`;
  }
};



// WEBPACK FOOTER //
// ./src/config.js